import TemplateDetails from './TemplateDetails';

export default TemplateDetails; 
